import { render, staticRenderFns } from "./StartseitePendenzenNewViva.vue?vue&type=template&id=5905544a"
import script from "./StartseitePendenzenNewViva.vue?vue&type=script&lang=js"
export * from "./StartseitePendenzenNewViva.vue?vue&type=script&lang=js"
import style0 from "./StartseitePendenzenNewViva.vue?vue&type=style&index=0&id=5905544a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports